// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "48e827f6e65a6f40b2411b87bf5c29b0a9d5a694/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};